const translation = {
  api_key: {
    title: 'API Key Management',
    alert: {
      line1:
        '• API Key is your important credential to request LLM services. API Keys are long-term valid. Do not share the key information in public, keep it safe and rotate regularly to avoid security risks or financial loss caused by unauthorized use.',
      line2:
        '• To ensure account security, we will automatically rotate detected leaked keys. API Keys can only be disabled and cannot be deleted.',
    },
    actions: {
      add: 'Add API Key',
      enable: 'Enable',
      disable: 'Disable',
      rename: 'Rename',
      copy_success: 'API Key copied to clipboard',
      copy_failed: 'Copy failed, please copy manually',
      create_success: 'API Key created successfully',
      create_failed: 'Failed to create API Key, please retry',
      rename_success: 'Name updated successfully',
      rename_failed: 'Failed to update name, please retry',
      status_success: 'Status updated',
      status_failed: 'Failed to update status, please retry',
      fetch_key_failed: 'Failed to get API Key',
    },
    filters: {
      all: 'All',
      mine: 'Created by me',
    },
    columns: {
      name_id: 'Name / ID',
      api_key: 'API Key',
      status: 'Status',
      created_at: 'Created At',
      last_used_at: 'Last Used At',
      creator: 'Creator',
      operation: 'Operation',
      status_values: {
        active: 'Active',
        disabled: 'Disabled',
      },
    },
    tooltip: {
      last_used_at:
        'The most recent time this API Key was used for API authentication. This data may have minute-level latency (updated every 5 minutes).',
    },
    empty: 'No API Key data',
    pagination_total: 'Total {{total}}',
    confirm: 'Confirm',
    cancel: 'Cancel',
    dialogs: {
      add_title: 'Add API Key',
      rename_title: 'Rename',
      disable_confirm_title: 'Are you sure to disable this API Key?',
      disable_confirm_content: 'Name: {{name}}',
    },
    form: {
      name: 'API Name',
      name_placeholder: 'Please enter API name',
      validation: {
        name_required: 'Please enter API name',
        name_too_long: 'Up to 20 characters',
        name_pattern:
          'Must start with Chinese or English letters, can contain numbers and symbols -_',
      },
    },
  },
  models: {
    title: 'Model Square',
    search_placeholder: 'Please enter model name',
    filter: {
      title: 'Filter Models',
      clear: 'Clear',
      confirm: 'Search',
      scenarios: 'Task Scenarios',
      model_size: 'Model Size',
      context_length: 'Context Length',
      provider: 'Supported Chips',
    },
    pagination: {
      total: '{{start}}-{{end}} of {{total}} items',
    },
    actions: {
      view_detail: 'View Details',
      api_reference: 'API Reference',
      try_now: 'Try Now',
    },
    status: {
      offline: 'Offline',
    },
  },
  model_detail: {
    title: 'Model Details',
    tabs: {
      details: 'Details',
      usage: 'Usage',
      api_docs: 'API Docs',
    },
    sections: {
      introduction: 'Introduction',
      tags: 'Tags',
      api_docs: 'API Docs',
      related_docs: 'Related Docs',
      api_key: 'API Key',
      call_example: 'Examples',
    },
    actions: {
      view_api_docs: 'View API Docs',
      view_related_docs: 'View Docs',
      get_api_key: 'Get API Key',
      try_now: 'Try Now',
      view: 'View',
    },
    tips: {
      api_key: 'Create a new API Key or copy an existing one.',
    },
    example: {
      shell_curl: 'Shell / cURL',
      python: 'Python',
      nodejs: 'Node.js',
      sample_question: 'Who are you?',
    },
    fields: {
      model_name: 'Model Name',
      provider: 'Provider',
      context_length: 'Context Length',
      max_generate_length: 'Max Generation Length',
      created_at: 'Created At',
      statistics: 'Usage Statistics',
      price_input: 'Input Price',
      price_output: 'Output Price',
    },
    empty: {
      introduction: 'No introduction yet',
      api_docs: 'No API documentation available',
    },
    not_found: 'Model Not Found',
    not_found_desc: 'The requested model does not exist or has been deleted',
    messages: {
      copy_code_success: 'Code copied to clipboard',
      copy_name_success: 'Model name copied to clipboard',
      copy_failed: 'Copy failed',
    },
    errors: {
      fetch_failed: 'Failed to fetch model details',
      fetch_failed_retry: 'Failed to fetch model details, please try again later',
    },
    status: {
      online: 'Online',
      offline: 'Offline',
    },
    common: {
      error: 'Error',
      unknown: 'Unknown',
    },
    price: {
      yuan_per_million_tokens: '¥{{price}} per million tokens',
      free: 'Free',
    },
  },
  model_service_prices: {
    title: 'Model Service Prices',
    price_list: 'Service Price List',
    tip: 'This price list is only for users who use API call services. Client experience users are not charged.',
    columns: {
      model_name: 'Model Name',
      model_type: 'Model Type',
      provider: 'Provider',
      input_price: 'Input Price',
      output_price: 'Output Price',
      action: 'Action',
      usage_statistics: 'Usage Statistics',
      view_detail: 'View Details',
    },
    default_model_type: 'Large Language Model',
    free_quota: 'Free Quota',
    yuan_per_million_tokens: 'per million tokens',
    pagination_total: 'Total {{total}}',
    errors: {
      fetch_price_failed: 'Failed to fetch price',
      fetch_models_failed: 'Failed to fetch model list',
    },
  },
  trial: {
    title: 'Trial Center',
    model_selection: 'Model Selection',
    select_model_placeholder: 'Select Large Language Model',
    interaction_config: 'Interaction Config',
    stream: 'Stream',
    stream_tooltip: 'Whether to use streaming to return model generation results.',
    stream_enabled: 'Enabled',
    stream_disabled: 'Disabled',
    system_prompt: 'System Prompt',
    system_prompt_tooltip: 'The system does not save custom prompts. If the content you enter is too long, it may be truncated.',
    system_prompt_placeholder: 'The system does not save custom prompts. If the content you enter is too long, it may be truncated',
    system_prompt_edit: 'System Prompt Editor',
    context_length: 'Context Length',
    context_length_tooltip: 'The maximum amount of text that a model can receive and understand in one processing, including input prompts and model-generated replies, measured in "tokens".',
    max_tokens: 'Max_tokens',
    max_tokens_tooltip: 'The maximum number of tokens for model output.',
    temperature: 'Temperature',
    temperature_tooltip: 'Sampling temperature, controls the randomness of output. Higher values make the output more random and creative; lower values make the output more focused and deterministic. We recommend adjusting top_p or temperature parameters according to your application scenario, but do not recommend adjusting both parameters at the same time.',
    top_p: 'Top_p',
    top_p_tooltip: 'Used to control the randomness and diversity of output text. The larger the value, the richer the generated text. We recommend adjusting top_p or temperature parameters according to your application scenario, but do not recommend adjusting both parameters at the same time.',
    clear_messages: 'Clear Messages',
    confirm: 'Confirm',
    cancel: 'Cancel',
    errors: {
      restore_system_prompt_failed: 'Failed to restore System Prompt',
      save_system_prompt_failed: 'Failed to save System Prompt',
      request_failed: 'Request failed',
      cannot_read_response_stream: 'Cannot read response stream',
      unknown_error: 'Unknown error',
      messages_cleared: 'Messages cleared',
      clear_messages_failed: 'Failed to clear messages',
      select_model_first: 'Please select a model first',
      model_call_failed: 'Model call failed: {{error}}',
      model_response_format_error: 'Model response format error',
      model_call_failed_retry: 'Model call failed, please try again later',
    },
    placeholder: {
      input_instruction: 'Please give me instructions, I can complete dialogue chat, intelligent Q&A, code generation and other tasks...',
    },
    empty_state: {
      welcome: 'Welcome to try',
      model: 'model',
      description1: 'You can enter questions below or click recommended examples to try the model capabilities for free',
      description2: 'Please note that the model may not be able to answer inappropriate questions',
      ai_assistant: 'AI Assistant',
    },
  },
  statistics: {
    load_api_keys_failed: 'Failed to load API Key list',
    fetch_statistics_failed: 'Failed to fetch statistics, please retry',
    select_user_account: 'Please select user account',
    filter_tip: 'Filtering will be performed by execution completion time. Due to large data volume, querying usage data over 30 days may take 5-10 seconds.',
    time_range_limit: 'The query time range is limited to the last 3 months of data.',
    api_only_tip: 'Currently only statistics from API calls are counted.',
  },
}

export default translation


